import { IApplicationState } from '../../types/redux';

export const selectIsOffersExist = (state: IApplicationState) => {
  return Boolean(state.landing.offersLength && state.landing.offersLength > 0);
};
